import { supabase } from "@/integrations/supabase/client";
import type { UserRoles } from "./userRoles";

export type UserRoleResult = { kind: "role"; role: UserRoles } | { kind: "no-role" } | { kind: "error" };

/**
 * Securely fetches the user's role from the user_roles table.
 *
 * Distinguishes three outcomes so callers can tell a genuine "no role yet"
 * (a successful query that returned zero rows) from a failed lookup. Only the
 * former should route a user to the no-role page; an error must stay an error.
 */
export async function fetchUserRole(userId: string): Promise<UserRoleResult> {
  try {
    const { data, error } = await supabase.from("user_roles").select("role").eq("user_id", userId).maybeSingle();

    if (error) {
      console.error("Error fetching user role:", error);
      return { kind: "error" };
    }

    if (!data?.role) {
      return { kind: "no-role" };
    }

    return { kind: "role", role: data.role as UserRoles };
  } catch (error) {
    console.error("Error fetching user role:", error);
    return { kind: "error" };
  }
}
